var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnwindExpFilled = function SvgUnwindExpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    fill: "#827127",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.08 1.75c.44 0 .795.356.795.795 0 1.099-.89 1.99-1.989 1.99h-.795a.796.796 0 0 0-.795.795h2.694a4.773 4.773 0 0 1 4.758 4.389l.491 6.093a3.18 3.18 0 0 1-3.171 3.438h-.115a3.18 3.18 0 0 1-2.846-1.759l-.712-1.423h-3.79l-.712 1.423a3.18 3.18 0 0 1-2.846 1.759h-.115a3.18 3.18 0 0 1-3.172-3.438l.492-6.093c.2-2.48 2.27-4.39 4.758-4.39h2.694a2.387 2.387 0 0 1 2.387-2.386h.796c.22 0 .397-.178.397-.398 0-.439.356-.795.796-.795M8.51 9.307a.796.796 0 0 0-1.591 0v.795h-.796a.795.795 0 1 0 0 1.591h.796v.796a.795.795 0 1 0 1.591 0v-.796h.796a.796.796 0 0 0 0-1.59H8.51zm4.177-.796a.994.994 0 1 0 0 1.99.994.994 0 0 0 0-1.99m1.989 2.785a.994.994 0 1 0 0 1.988.994.994 0 0 0 0-1.989",
    clipRule: "evenodd"
  })));
};
export default SvgUnwindExpFilled;